import { Chip, useDeviceType } from '@braskai/ui-kit';

import { Stack, Typography } from '@mui/material';

import type { TrialPlan } from '../model/PLANS';

export type PlanOptionProps = {
  isSelected: boolean;
  onSelectPlan: (planName: TrialPlan['name']) => void;
} & TrialPlan;

export const PlanOption = ({ name, chipLabel, isSelected, minutes, price, onSelectPlan }: PlanOptionProps) => {
  const { isMobile } = useDeviceType();
  return (
    <Stack
      sx={(theme) => ({
        border: isSelected ? '3px solid' : '1px solid',
        borderColor: isSelected ? theme.palette.primary[500] : theme.palette.grey[300],
        borderRadius: 16,
        cursor: 'pointer',
        position: 'relative',
        width: isMobile ? '100%' : 320,
      })}
      data-testid="plan-option-stack"
      direction="column"
      gap={24}
      justifyContent="space-between"
      padding={isSelected ? 14 : 16}
      onClick={() => onSelectPlan(name)}
    >
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="title-4-sb">{name}</Typography>
        <Stack alignItems="baseline" direction="row" spacing={4}>
          <Typography variant="title-4-sb">{price}</Typography>
          <Typography color="grey.500" variant="body-2">
            /per minute
          </Typography>
        </Stack>
      </Stack>
      <Typography color="grey.500" variant="body-2">
        {minutes} minutes
      </Typography>
      {isSelected && (
        <Chip
          label={chipLabel}
          sx={{
            backgroundColor: 'primary.500',
            color: 'common.white',
            position: 'absolute',
            right: 40,
            top: -12,
          }}
        />
      )}
    </Stack>
  );
};
